import FirestoreDataClass from "./_baseClasses";

export default class UserAccount extends FirestoreDataClass {
  static collectionName = "user_roles";
  static APIResourceName = "users";
}
